import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

export async function GetAllSizes() {
  const respone = await axios.get(`${getEndpoint()}/api/Sizes/GetAll`, ngrokSkipWarning);
  return respone.data;
}

export async function GetAllSizesOfProduct(id: string){
  const response = await axios.get(`${getEndpoint()}/api/Sizes/GetByProductId?id=${id}`, ngrokSkipWarning);
  return response.data;
}

